var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXmarkLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1759 13.177C12.9675 13.3854 12.6303 13.3854 12.4216 13.177L7.99992 8.75377L3.5772 13.177C3.3688 13.3854 3.03161 13.3854 2.82297 13.177C2.61457 12.9685 2.61457 12.6313 2.82297 12.4227L7.24669 8.00046L2.82364 3.57726C2.61524 3.36883 2.61524 3.03161 2.82364 2.82295C3.03205 2.61452 3.36923 2.61452 3.57787 2.82295L7.99992 7.24715L12.4226 2.82395C12.631 2.61552 12.9682 2.61552 13.1769 2.82395C13.3853 3.03237 13.3853 3.3696 13.1769 3.57826L8.75315 8.00046L13.1759 12.4237C13.3858 12.6303 13.3858 12.9703 13.1759 13.177Z",
    fill: "#1D2226"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmarkLight);
export default __webpack_public_path__ + "static/media/xmark-light.72e043fbf05a856e72fb8847c96661ef.svg";
export { ForwardRef as ReactComponent };